//API Loader Events
export const SHOW_API_LOADING = "api:show_loader"
export const HIDE_API_LOADING = "api:hide_loader"

//Product Related Events
export const RESET_PRODUCT_CARD = "product:reset_card"
export const QTY_ADDED_TO_CART = "api:qty_added_to_cart"
